export default __webpack_public_path__ + "static/media/dv-bebidas.8bd964cd.svg";